import { initFrameAndPoll } from '@newswire/frames';
import { json } from 'd3-fetch';
import { index } from 'd3-array';

import { renderSvelteComponent } from './utils/render.js';
import Lookup from './components/Lookup.svelte';

initFrameAndPoll();

async function main() {
  // test dictionary
  const dataurl = new URL('../scripts/chip_data.json', import.meta.url);
  const data = await json(dataurl);

  const crosswalk = index(window.CROSSWALK, (d) => d.microchip);

  renderSvelteComponent(Lookup, document.getElementById('lookup'), {
    data: data,
    crosswalk,
  });
}
main();
